  export const bankCodes = [
    {
      id:11,
      codigo:'0102',
      text:`Se solicita desde la página web de Banco de Venezuela o 
      SMS 2661 o 2662 + cedula`
    },
    {
      id:3,
      codigo:'0191',
      text:`Pestaña Pagos/Pago Móvil -> Generador Clave C2P`
    },{
      id:23,
      codigo:'0108',
      text:`Dinero Rápido -> QuieroGenerar Clave de Compra -> Generar `
    },{
      id:12,
      codigo:'0114',
      text:`Mi Pago Bancaribe -> Clave Mi Pago Comercio`
    },{
      id:16,
      codigo:'0115',
      text:`Envíe al 278 el texto CLAVE V su número de cédula (o E si es extranjero).`
    },{
      id:14,
      codigo:'0163',
      text:`Debe ingresar a la aplicación “Tesoro Pago Móvil (P2P) y solicitar en esa APP la clave.
      O envíe al 2383 el texto "Comercio" + V + su número de cédula + (una coordenada a elegir)`
    },{
      id:2,
      codigo:'0134',
      text:`Generar Claves Dinámicas a través del portal de Mis Solicitudes banesco o enviando un SMS al número 2846 de la siguiente forma:
      Coloca la palabra clave dinamica, el tipo de literal: V, E ó J, según sea el caso, y el número de cédula o RIF. Recuerda dejar un espacio entre cada dato. Ejemplo: clave dinamica V 00000000`
    },{
      id:22,
      codigo:'0138',
      text:`Tu DineroYa -> Generar Token.
      Envíe al 1470 el texto: CLAVE V su número de cédula. (o E si es extranjero).
      Tu Plaza en Línea`
    },{
      id:29,
      codigo:'0174',
      text:`Pago Plus -> Clave C2P`
    },{
      id:35,
      codigo:'0169',
      text:`Envíe al 22622 el texto: PAGAR`
    },{
      id:32,
      codigo:'0157',
      text:`Envíe al 78910 el texto COBROD2`
    },{
      id:25,
      codigo:'0168',
      text:`Pag@Ya de Bancrecer. Ahí encuentra la clave C2P.`
    },{
      id:6,
      codigo:'0171',
      text:`Pago Activo. Ahí encuentra la clave C2P.
      Envíe al 228486 el texto C2P+TIPO DE DOCUEMENTO+NUMERO DE DOCUMENTO`
    },{
      id:33,
      codigo:'0151',
      text:`Pago Móvil BFC. Ahí encuentra la clave C2P`
    },{
      id:5,
      codigo:'0172',
      text:`Se obtiene al entrar a Bancamiga Suite y después a Pago Móvil.`
    },{
      id:19,
      codigo:'0105',
      text:`Via APP de Tpago en el botón Clave C2P o a través de un SMS al 24024 con la palabra ...`
    },{
      id:27,
      codigo:'0177',
      text:`Envíe al 326200 si es Movistar o Digitel o 78900 si es Movilnet, el texto SERVICIO C2P`
    },{
      id:8,
      codigo:'0175',
      text:`En el menú principal da clic a Pago Móvil, escoge la opción Código de Autorización - C2P, por último, selecciona Solicitud del Código de Autorización.`
    },{
      id:36,
      codigo:'0137',
      text:`Sofitasa Pago Móvil. Ahí encuentra la clave P2C.
      Sofinet personas`
    },{
      id:7,
      codigo:'0166',
      text:`Banca Móvil o e-banca Personas generarr Clave Dinámica.`
    },{
      id:9,
      codigo:'0128',
      text:`Web Móvil → Solicitud del Código de Autorización
      Envíe al 100102 el texto: C2P + PAGO + (la clave de transacciones especiales de Pago Móvil) →
      Le enviarán la Clave C2P.`
    },{
      id:20,
      codigo:'0156',
      text:`Via APP o web 100% Internet Personas y a través de la Web Móvil. Generar Clave Dinamica`
    },{
      id:24,
      codigo:'0104',
      text:`Venezolano de Crédito AppBvc -> Clave C2P
      Venezolano Online`
    },
  ];